import React, { useEffect } from 'react';
import { usePaymentProviderContext } from '../../Session/PaymentProviderContext';
import { ContainerModern, Loader } from '../common';

export const Login: React.FC = () => {
  const { isLoading, paymentProvider } = usePaymentProviderContext();

  useEffect(() => {
    if (!isLoading) {
      const path = paymentProvider ? 'account#!/subscription' : '/account#!/upload';
      window.location.assign(new URL(path, window.location.origin));
    }
  }, [paymentProvider, isLoading]);

  return (
    <ContainerModern>
      <Loader />
    </ContainerModern>
  );
};
